import { memo } from 'react';

import * as classes from './styles.module.scss';

const Bouncer = () => {
  return (
    <div className={classes.loader}>
      <div className={classes.bounce} />
      <div className={classes.bounce} />
      <div className={classes.bounce} />
    </div>
  );
};

export default memo(Bouncer);
